import SIGNER from './signer-constants';
import CONTACT from './contact-constants';
import AUTHS from './auths-constants';
import HOVER_INFO from './hover-info-constants';

export default { ...SIGNER, ...CONTACT, ...AUTHS, ...HOVER_INFO };
